module.exports = "<div class=q-marg-vert-lg> <div class=row> <div class=\"col-lg-3 q-pad-vert-xxs\"> {%-name%}: </div> <div class=\"col-lg-3 q-marg-bottom-md-at-md\"> <div class=error-wrapper> <input type=text id=\"{%-key%}\" name=\"{%-key%}\" class=\"q-input q-stretch\" placeholder=\"Type {%-name%}\" value=\"{%-value%}\" data-error-placement-append-closest=.error-wrapper /> </div> </div> <div class=col-lg-6> </div> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/report/lookup/html/inputParam.html
// module id = 1401
// module chunks = 1